<template>
    <div class="user-center">
        <div class="user-center-header">
            <div class="header-identity">
                <span>卡号：13918888888</span>
            </div>
            <div class="header-info">

            </div>
            <ul class="header-use-favourable">
                <router-link tag="li" to="/my/integral/list">
                    <strong>1000</strong>
                    <span>积分</span>
                </router-link>
                <li>
                    <strong>12</strong>
                    <span>优惠券</span>
                </li>
                <li>
                    <strong>6</strong>
                    <span>达美乐电子预付卡</span>
                </li>
            </ul>
        </div>
        <div class="user-center-body">
            <div class="user-center-new">
                <h5>
                    <span>最新动态</span>
                    <em>08/31</em>
                </h5>
                <div>
                    <span>订单 20180931PA00001 已完成</span>
                    <em>去抽奖</em>
                </div>
            </div>

            <div class="gap"></div>

            <div class="user-my-order">
                <h5>
                    <span>我的订单</span>
                </h5>
                <ul>
                    <li>
                        <i class="dmicon dm-dingdan"></i>
                        <span>历史订单</span>
                    </li>
                    <li>
                        <i class="dmicon dm-pay"></i>
                        <span>待付款</span>
                    </li>
                    <li>
                        <i class="dmicon dm-jieshouguanli-xiugai"></i>
                        <span>待收/取餐</span>
                    </li>
                </ul>
            </div>

            <div class="gap"></div>

            <div class="user-actions">
                <ul>
                    <li>
                        <i class="dmicon dm-dizhi1"></i>
                        <span>我的地址</span>
                    </li>
                    <li>
                        <i class="dmicon dm-fapiaofuwuxianxing"></i>
                        <span>我的发票</span>
                    </li>
                    <li>
                        <i class="dmicon dm-kefu"></i>
                        <span>联系客服</span>
                    </li>
                    <li>
                        <i class="dmicon dm-assist"></i>
                        <span>邀请好友</span>
                    </li>
                    <li>
                        <i class="dmicon dm-chaxuntongji"></i>
                        <span>门店查询</span>
                    </li>
                    <li>
                        <i class="dmicon dm-bangzhu"></i>
                        <span>帮助中心</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="user-center-footer">

        </div>
    </div>
</template>

<script>

	import layoutStore from '@app/home/layout/layout.store';

	export default {
		name: 'myIndex',
		components: {},
		created() {
			setLayout()
		},
		beforeRouteEnter(to, from, next) {
			setLayout()
			next()
		}
	}

	// 设置页面layout
	function setLayout() {
		layoutStore.commit('setHeader', {
			type: 'left',
			conf: {
				html: '<i class="dmicon dm-shezhi2" style="font-size: 0.65rem;color:white;"></i>'
			}
		});
		layoutStore.commit('setHeader', {
			type: 'right',
			conf: {
				html: '<i class="dmicon dm-buoumaotubiao14" style="font-size: 0.65rem;color:white;"></i>'
			}
		});
		// 设置header样式
		layoutStore.state.headerStyle = {
			boxShadow: 'none',
			backgroundColor: '#1878AE'
		}
	}
</script>

<style lang="scss" scoped>
    $bg-color: #1878AE;
    $padding: 10px;

    .user-center {
        background-color: #F2F2F2 !important;
    }

    .user-center-header {
        padding: 0 $padding 20px;
        background-color: $bg-color;
    }

    .header-identity {
        height: 60px;
    }

    .header-use-favourable {
        display: flex;
        flex-direction: row;
        li {
            width: (100% / 3);
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }

    .user-center-body {
        padding: 10px $padding;
    }

    .user-my-order, .user-center-new {
        padding: 5px;
        background-color: white;
        border-radius: 5px;
        h5 {
            display: flex;
            padding-top: 5px;
            padding-bottom: 10px;
            justify-content: space-between;
            border-bottom: solid 1px #efefef;
        }
        > div {
            display: flex;
            padding-top: 10px;
            padding-bottom: 5px;
            justify-content: space-between;
        }
    }

    .gap {
        height: $padding;
    }

    .user-my-order {
        ul {
            display: flex;
            flex-direction: row;
            padding-top: $padding;
        }
        li {
            width: (100% / 3);
            display: flex;
            flex-direction: column;
            align-items: center;
            span {
                font-size: 12px;
            }
        }
        i{
            font-size: 22px;
        }
    }

    .user-actions {
        padding: 5px;
        background-color: white;
        border-radius: 5px;
        ul {
            display: flex;
            flex-wrap: wrap;
        }
        li {
            width: (100% / 3);
            display: flex;
            padding: 10px 0;
            flex-direction: column;
            align-items: center;
            &:nth-child(6n+1){
                i{
                    background-color: #37da51;
                }
            }
            &:nth-child(6n+2){
                i{
                    background-color: #37b6da;
                }
            }
            &:nth-child(6n+3){
                i{
                    background-color: #dabd37;
                }
            }
            &:nth-child(6n+4){
                i{
                    background-color: #be25ca;
                }
            }
            &:nth-child(6n+5){
                i{
                    background-color: #ca257b;
                }
            }
            &:nth-child(6n+6){
                i{
                    background-color: #25ca93;
                }
            }
        }
        i {
            width: 40px;
            height: 40px;
            color: white;
            font-size: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            background-color: pink;
        }
        span {
            font-size: 12px;
            padding-top: 5px;
        }
    }
</style>